// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_box {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    padding-bottom: 0px !important;
    font-family: 'Roboto Mono', monospace;
    color: #333;
}

.home {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    font-family: 'Roboto Mono', monospace;
    color: #333;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
}

.logo {
    color: #002475;
    font-size: 24px;
    font-weight: bold;
}

.logo.asxn-logo {
    font-family: 'Libre Baskerville', serif;
    /* Add any other specific styles for the logo on the home page */
}

.main-title-link {
    text-decoration: none;
    display: block;
    text-align: center;
    margin-bottom: 30px;
}

.main-title {
    color: #002475;
    font-size: 24px;
    font-weight: bold;
    display: inline-block;
    position: relative;
    cursor: pointer;
}

.main-title::after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -5px;
    left: 50%;
    background-color: #002475;
    transition: all 0.3s ease-in-out;
}

.main-title:hover::after {
    width: 100%;
    left: 0;
}

.dashboard-groups {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 40px;
}

.dashboard-group {
    background-color: #f0f0f0;
    border: 1px solid #002475;
    /* Change this line to use the blue color */
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
}

/* If you have any hover effects, you might want to update those as well */
.dashboard-group:hover {
    box-shadow: 0 0 10px rgba(0, 36, 117, 0.1);
    /* Subtle blue shadow on hover */
}

.group-title {
    color: #002475;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
}

.dashboard-links {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.dashboard-link {
    display: inline-block;
    padding: 10px 15px;
    background-color: white;
    border: 1px solid #002475;
    border-radius: 4px;
    color: #002475;
    text-decoration: none;
    text-align: center;
    font-size: 14px;
    transition: background-color 0.3s, color 0.3s;
}

.dashboard-link:hover {
    background-color: #002475;
    color: white;
}

.logo-link {
    text-decoration: none;
    position: relative;
    display: inline-block;
}

.logo.asxn-logo {
    font-family: 'Libre Baskerville', serif;
    /* Add any other specific styles for the logo on the home page */
}

.logo-link::after {
    content: '';
    position: absolute;
    width: 0;
    height: 1px;
    bottom: -4px;
    left: 50%;
    background-color: #002475;
    transition: all 0.3s ease-in-out;
}

.logo-link:hover::after {
    width: 100%;
    left: 0;
}

@media (max-width: 768px) {
    .dashboard-groups {
        grid-template-columns: 1fr;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Home.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,gEAAgE;AACpE;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,OAAO;AACX;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA,0EAA0E;AAC1E;IACI,0CAA0C;IAC1C,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,uCAAuC;IACvC,gEAAgE;AACpE;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,OAAO;AACX;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".header_box {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    padding-bottom: 0px !important;\n    font-family: 'Roboto Mono', monospace;\n    color: #333;\n}\n\n.home {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: 'Roboto Mono', monospace;\n    color: #333;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n}\n\n.logo {\n    color: #002475;\n    font-size: 24px;\n    font-weight: bold;\n}\n\n.logo.asxn-logo {\n    font-family: 'Libre Baskerville', serif;\n    /* Add any other specific styles for the logo on the home page */\n}\n\n.main-title-link {\n    text-decoration: none;\n    display: block;\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.main-title {\n    color: #002475;\n    font-size: 24px;\n    font-weight: bold;\n    display: inline-block;\n    position: relative;\n    cursor: pointer;\n}\n\n.main-title::after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 2px;\n    bottom: -5px;\n    left: 50%;\n    background-color: #002475;\n    transition: all 0.3s ease-in-out;\n}\n\n.main-title:hover::after {\n    width: 100%;\n    left: 0;\n}\n\n.dashboard-groups {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 40px;\n}\n\n.dashboard-group {\n    background-color: #f0f0f0;\n    border: 1px solid #002475;\n    /* Change this line to use the blue color */\n    border-radius: 8px;\n    padding: 20px;\n    margin-bottom: 20px;\n}\n\n/* If you have any hover effects, you might want to update those as well */\n.dashboard-group:hover {\n    box-shadow: 0 0 10px rgba(0, 36, 117, 0.1);\n    /* Subtle blue shadow on hover */\n}\n\n.group-title {\n    color: #002475;\n    font-size: 18px;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.dashboard-links {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.dashboard-link {\n    display: inline-block;\n    padding: 10px 15px;\n    background-color: white;\n    border: 1px solid #002475;\n    border-radius: 4px;\n    color: #002475;\n    text-decoration: none;\n    text-align: center;\n    font-size: 14px;\n    transition: background-color 0.3s, color 0.3s;\n}\n\n.dashboard-link:hover {\n    background-color: #002475;\n    color: white;\n}\n\n.logo-link {\n    text-decoration: none;\n    position: relative;\n    display: inline-block;\n}\n\n.logo.asxn-logo {\n    font-family: 'Libre Baskerville', serif;\n    /* Add any other specific styles for the logo on the home page */\n}\n\n.logo-link::after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 1px;\n    bottom: -4px;\n    left: 50%;\n    background-color: #002475;\n    transition: all 0.3s ease-in-out;\n}\n\n.logo-link:hover::after {\n    width: 100%;\n    left: 0;\n}\n\n@media (max-width: 768px) {\n    .dashboard-groups {\n        grid-template-columns: 1fr;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
